<template>
  <div>
    <base-head-listing-page :page="page" :filter="filter" :tableFilter="tableFilter" :search="search">
      <template #content="{ model }">
        <b-table :id="`${modelName}-list`" :sort-by.sync="filter.sortBy" :sort-desc.sync="sortDesc"
          :filter="tableFilter" :items="models" :fields="getColumnsWithAction()" thead-class="list"
          v-on="tableListeners" ref="table" :selectable="selectable" :select-mode="selectMode">
          <template #cell(actions)="{ item, ...row }">
            <slot name="actions" :model="item" v-bind="row"></slot>
          </template>

          <template v-for="name in tableSlots" v-slot:[name]="data">
            <slot :name="'table:' + name" v-bind="data" />
          </template>
        </b-table>
      </template>
    </base-head-listing-page>
  </div>
</template>

<script>
import { fetchModel } from '../../utils';
import { capitalize } from 'lodash';
import BaseHeadListingPage from './BaseHeadListingPage.vue';

export default {
  props: ['moduleName', 'modelName', 'alertFetchName', 'columns', 'service', 'defaultFilter', 'fetch', 'noAdd', 'noEdit', 'noFilter', 'editPageName', 'newPageName', 'noActions', 'search', "selectable", "selectMode"],
  components: { BaseHeadListingPage },
  data() {
    return {
      models: [],
      filter: this.getDefaultFilter(),
      tableFilter: null,
      page: null,
      sortDesc: true
    };
  },
  mounted() {
    this.fetchModels();
  },
  computed: {
    tableSlots() {
      return Object.keys(this.$scopedSlots)
        .filter(k => /^table:(.*)$/.test(k))
        .map(k => k.replace("table:", ""));
    },
    tableListeners() {
      return Object.entries(this.$listeners)
        .filter(([k]) => /^table:(.*)$/.test(k))
        .map(([k, v]) => [k.replace("table:", ""), v])
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
    }
  },
  methods: {
    capitalize,
    getDefaultFilter() {
      return this.defaultFilter ? this.defaultFilter() : {};
    },
    getColumnsWithAction() {
      if (this.noActions) return this.columns;
      return [
        ...this.columns,
        { key: 'actions', label: "Ações" },
      ];
    },
    getEditPageName() {
      return this.editPageName || `${this.moduleName}-${this.modelName}-id`;
    },
    getNewPageName() {
      return this.newPageName ? { name: this.newPageName } : this.getUrl() + '/novo';
    },
    getUrl() {
      return `/${this.moduleName}/${this.modelName}`;
    },
    clearFilter() {
      this.filter = this.getDefaultFilter();
    },
    async fetchModels() {
      let fetch = this.getFetchMethod();
      this.page = await fetch();
      this.models = this.page.content;
      this.$emit('models-loaded', this.models);
    },
    getFetchMethod() {
      if (this.fetch)
        return () => this.fetch(this.filter);

      let fetch = () => this.service.filter(this.filter);
      if (this.noFilter) fetch = () => this.service.list();
      return () => fetchModel(this.alertFetchName, fetch);
    },
    updateModelAt(index, model) {
      this.$set(this.models, index, model);
    },
    updateModelWhere(predicate, model) {
      let index = this.models.findIndex(predicate);
      this.updateModelAt(index, model);
    },
    sortDirection() {
      return this.sortDesc ? 'desc' : 'asc';
    }
  },
  watch: {
    'filter.page': {
      handler() {
        this.fetchModels();
      }
    },
    'filter.size': {
      handler() {
        this.fetchModels();
      }
    },
    'filter.sortBy': {
      handler() {
        this.filter.page = 1;
        this.fetchModels();
      }
    },
    'sortDesc': {
      handler() {
        this.filter.page = 1;
        this.filter.sortDirection = this.sortDirection();
        this.fetchModels();
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/shared/BaseListingPage.vue